import * as R from 'ramda';

export const isError = (arg: unknown): arg is Error =>
  !!arg &&
  typeof arg === 'object' &&
  'message' in arg &&
  'name' in arg &&
  'stack' in arg;

export type Dispatcher<
  TEvents extends Record<keyof TEvents, CustomEvent<unknown>>
> = {
  [Property in keyof TEvents]: TEvents[Property]['detail'];
};

export const formatTime = (time: Date): string => {
  if(!time) return '';
  const hours = time.getHours();
  const minutes = time.getMinutes();
  const ampm = hours >= 12 ? 'pm' : 'am';
  const hour = hours % 12 || (hours == 12 ? 12 : 0);
  return `${hour}:${minutes.toString().padStart(2, '0')} ${ampm}`;
}

export const formatDateTime = (time: Date): string => {
  const date = time.toLocaleDateString();
  const timeString = formatTime(time);
  return `${date} ${timeString}`;
}

const baseUrl = 'https://areena.yle.fi';

export const buildPlayUrl = (episodeId: string, showTime?: Date, trackTime?: Date): string | null => {
  if(R.isNil(episodeId) || R.isEmpty(episodeId)) {
    return `${baseUrl}/1-65458240`;
  }
  if(R.isNil(showTime) || R.isNil(trackTime) || showTime.getTime() === trackTime.getTime()){
    return `${baseUrl}/${episodeId}`;
  }
  const offset = (trackTime.getTime() - showTime.getTime()) / 1000;
  return `https://areena.yle.fi/${episodeId}?seek=${offset}`;
}
